"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fields = void 0;

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("react");

var _utils = require("../../utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var UpperFloor = function UpperFloor(_ref) {
  var color = _ref.color,
      hideHEX = _ref.hideHEX,
      onChange = _ref.onChange;
  var getValueHEX = (0, _react.useCallback)(function () {
    return {
      value: color.hex,
      inputted: false
    };
  }, [color.hex]);

  var _useState = (0, _react.useState)(getValueHEX),
      _useState2 = _slicedToArray(_useState, 2),
      valueHEX = _useState2[0],
      setValueHEX = _useState2[1];

  (0, _react.useEffect)(function () {
    if (!valueHEX.inputted) {
      setValueHEX(getValueHEX);
    }
  }, [valueHEX.inputted, getValueHEX]);

  var changeHEX = function changeHEX(e) {
    var value = e.target.value;

    if ((0, _utils.isValidHEX)(value)) {
      onChange((0, _utils.toColor)("hex", value));
      setValueHEX(_objectSpread(_objectSpread({}, valueHEX), {}, {
        value: value
      }));
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: !hideHEX && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "rcp-fields-floor",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "rcp-fields-element",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          className: "rcp-fields-element-input",
          value: valueHEX.value,
          onFocus: function onFocus() {
            return setValueHEX(_objectSpread(_objectSpread({}, valueHEX), {}, {
              inputted: true
            }));
          },
          onChange: changeHEX,
          onBlur: function onBlur() {
            return setValueHEX(_objectSpread(_objectSpread({}, valueHEX), {}, {
              inputted: false
            }));
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
          className: "rcp-fields-element-label",
          children: "HEX"
        })]
      })
    })
  });
};

var LowerFloor = function LowerFloor(_ref2) {
  var color = _ref2.color,
      hideRGB = _ref2.hideRGB,
      hideHSB = _ref2.hideHSB,
      onChange = _ref2.onChange;
  var getValueRGB = (0, _react.useCallback)(function () {
    return {
      value: "".concat(color.rgb.r, ", ").concat(color.rgb.g, ", ").concat(color.rgb.b),
      inputted: false
    };
  }, [color.rgb]);
  var getValueHSB = (0, _react.useCallback)(function () {
    return {
      value: "".concat(Math.round(color.hsb.h), "\xB0, ").concat(Math.round(color.hsb.s), "%, ").concat(Math.round(color.hsb.b), "%"),
      inputted: false
    };
  }, [color.hsb]);

  var _useState3 = (0, _react.useState)(getValueRGB),
      _useState4 = _slicedToArray(_useState3, 2),
      valueRGB = _useState4[0],
      setValueRGB = _useState4[1];

  var _useState5 = (0, _react.useState)(getValueHSB),
      _useState6 = _slicedToArray(_useState5, 2),
      valueHSB = _useState6[0],
      setValueHSB = _useState6[1];

  (0, _react.useEffect)(function () {
    if (!valueRGB.inputted) {
      setValueRGB(getValueRGB);
    }
  }, [valueRGB.inputted, getValueRGB]);
  (0, _react.useEffect)(function () {
    if (!valueHSB.inputted) {
      setValueHSB(getValueHSB);
    }
  }, [valueHSB.inputted, getValueHSB]);

  var changeRGB = function changeRGB(e) {
    var value = e.target.value.match(/\d+/g);

    if (value && value.length === 3) {
      var rgb = (0, _utils.toValidRGB)(value.slice(0, 3));
      onChange((0, _utils.toColor)("rgb", rgb));
    }

    setValueRGB(_objectSpread(_objectSpread({}, valueRGB), {}, {
      value: e.target.value
    }));
  };

  var changeHSB = function changeHSB(e) {
    var value = e.target.value.match(/\d+/g);

    if (value && value.length === 3) {
      var hsb = (0, _utils.toValidHSB)(value.slice(0, 3));
      onChange((0, _utils.toColor)("hsb", hsb));
    }

    setValueHSB(_objectSpread(_objectSpread({}, valueHSB), {}, {
      value: e.target.value
    }));
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: (!hideRGB || !hideHSB) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "rcp-fields-floor",
      children: [!hideRGB && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "rcp-fields-element",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          className: "rcp-fields-element-input",
          value: valueRGB.value,
          onFocus: function onFocus() {
            return setValueRGB(_objectSpread(_objectSpread({}, valueRGB), {}, {
              inputted: true
            }));
          },
          onChange: changeRGB,
          onBlur: function onBlur() {
            return setValueRGB(_objectSpread(_objectSpread({}, valueRGB), {}, {
              inputted: false
            }));
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
          className: "rcp-fields-element-label",
          children: "RGB"
        })]
      }), !hideHSB && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "rcp-fields-element",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          className: "rcp-fields-element-input",
          value: valueHSB.value,
          onFocus: function onFocus() {
            return setValueHSB(_objectSpread(_objectSpread({}, valueHSB), {}, {
              inputted: true
            }));
          },
          onChange: changeHSB,
          onBlur: function onBlur() {
            return setValueHSB(_objectSpread(_objectSpread({}, valueHSB), {}, {
              inputted: false
            }));
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
          className: "rcp-fields-element-label",
          children: "HSB"
        })]
      })]
    })
  });
};

var Fields = function Fields(_ref3) {
  var color = _ref3.color,
      hideHEX = _ref3.hideHEX,
      hideRGB = _ref3.hideRGB,
      hideHSB = _ref3.hideHSB,
      onChange = _ref3.onChange;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: (!hideHEX || !hideRGB || !hideHSB) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "rcp-fields",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(UpperFloor, {
        color: color,
        hideHEX: hideHEX,
        onChange: onChange
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(LowerFloor, {
        color: color,
        hideRGB: hideRGB,
        hideHSB: hideHSB,
        onChange: onChange
      })]
    })
  });
};

exports.Fields = Fields;